module.exports = __webpack_public_path__ + "media/images/details1-59a85396f26763ba49bbfe8177096683.png";